import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import wm2 from "../Images/wm2.jpg";
import wm1 from "../Images/wm1.png";
import wm3 from "../Images/wm3.jpg";
import wm4 from "../Images/wm4.png";
import wm5 from "../Images/wm5.gif";
import wm6 from "../Images/wm6.gif";
import { project_name } from "../Config/config";

export default function WorkFlowManagement() {
  return (
    <>
      {/* <!-- Required meta tags --> */}
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta
        name="description"
        content="CRM workflows can also alert your team to major lead and prospect updates that could help you for your next customer or client. Best of all, CRM workflows are easy to set up"
      />
      <meta property="og:title" content="Workflow Management" />
      <meta property="og:type" content="article" />
      <meta
        property="og:url"
        content="https://entelipro.com/workflowmanagement"
      />
      <meta
        property="og:image"
        content="https://www.entelipro.com/static/media/wm2.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://www.entelipro.com/static/media/wm2.jpg"
      />
      <meta property="og:site_name" content="entelipro.com" />
      <meta
        property="og:description"
        content="CRM workflows can also alert your team to major lead and prospect updates that could help you for your next customer or client. Best of all, CRM workflows are easy to set up"
      />
      <meta property="og:locale" content="en_US" />

      <script type="application/ld+json">
        `
        {`"@context":"https://schema.org","@type":"WebPage","name":"Workflow Management",
    "logo":{"@type":"ImageObject","url":"https://www.entelipro.com/web/dist/img/u.png"},"url":"https://entelipro.com/workflowmanagement"`}
        `
      </script>

      <title>
        Workflow Management | Best CRM Software |Telecommunication Industry ::
        entelipro.com
      </title>

      <Navbar />
      {/* <!-- breadcrumbs --> */}
      <section class="w3l-inner-banner-main">
        <div class="about-inner inner2">
          <div class="container seen-w3">
            <ul class="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span class="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/pharmaceutical">
                  Telecommunication Industry
                  <span class="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li class="active">Workflow Management</li>
            </ul>
          </div>
        </div>
      </section>
      {/* <!-- breadcrumbs //--> */}
      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="main-titles-head text-center">
              <h3 class="header-name">
                {`${project_name}`} Workflow Management
              </h3>
            </div>
            <div class="cwp4-two row">
              <div class="col-xl-6 cwp4-image ">
                <img src={wm2} alt="product" class="img-responsive " />
              </div>
              <div class="cwp4-text col-xl-6">
                <p class="para">
                  With {`${project_name}`} workflows, you can automate several
                  sales, marketing, customer support, and account management
                  tasks, thus freeing your team's time for more complex,
                  meaningful tasks.{" "}
                </p>
                <br />{" "}
                <p class="para">
                  {" "}
                  CRM workflows can also alert your team to major lead and
                  prospect updates that could help you for your next customer or
                  client. Best of all, CRM workflows are easy to set up.
                </p>
                <br />
                <p class="para">
                  Workflow management helps you to automate your sales,
                  marketing, and support. You can automatically assign tasks to
                  users, based on the criteria defined in the rules and update
                  certain fields.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="cwp4-text col-xl-6">
                <h4>Benefits of Workflow Management</h4>
                <p class="para">
                  {" "}
                  1. Improves efficiency by eliminating the manual work of
                  assigning tasks.
                  <br /> <br />
                  2. Reduces operating costs. <br /> <br />
                  3. Improves business processes through standardized working
                  methods.
                  <br /> <br />
                  4. You can automatically assign tasks to users, based on the
                  criteria defined in the rules and update certain fields.
                  <br /> <br />
                </p>
              </div>
              <div class="col-xl-6 cwp4-image ">
                <img src={wm1} alt="product" class="img-responsive " />
              </div>
            </div>
          </div>
          <br />
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="left-text">
              <h3 class="header-name">
                {`${project_name}`} can automate a wide range of tasks
              </h3>
              <br /> <br />
            </div>
            <div class="cwp4-two row">
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">Email Newsletters </h3> <br />
                <p class="para">
                  Any time a customer joins your email list, your CRM can set up
                  an automated workflow to send the new subscriber an email
                  thanking them for joining and informing them what they can
                  expect from future newsletters or emails from your company.
                  Your workflow could also include internal measures, such as
                  generating a CRM file for the customer and appropriately
                  scoring your new lead.
                </p>
              </div>

              <div class="col-xl-6 cwp4-image ">
                <img src={wm3} alt="product" class="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="col-xl-6 cwp4-image ">
                <img src={wm4} alt="product" class="img-responsive " />
              </div>
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">Lead scoring </h3> <br />
                <p class="para">
                  CRM can also score leads any time they take actions that move
                  them through the sales funnel. It can also notify your sales
                  team of worthwhile lead follow-up opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">Lead alerts</h3> <br />
                <p class="para">
                  {" "}
                  CRM workflows can notify sales managers when leads that meet
                  certain criteria are entered into your database. You can also
                  set up workflows that alert your managers to key changes with
                  these accounts or when urgent follow-up is needed.
                </p>
              </div>

              <div class="col-xl-6 cwp4-image ">
                <img src={wm5} alt="product" class="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="w3l-content-with-photo-4">
        <div class="content-with-photo4-block">
          <div class="container">
            <div class="cwp4-two row">
              <div class="col-xl-6 cwp4-image ">
                <img src={wm6} alt="product" class="img-responsive " />
              </div>
              <div class="cwp4-text col-xl-6">
                <h3 class="header-name">Customer service</h3> <br />
                <p class="para">
                  With CRM workflows, you can automate the process through which
                  help tickets get completed. You can send customer service
                  emails, flag customers for personal follow-up, and alert
                  relevant support reps. These workflows can also escalate and
                  de-escalate issues or close help tickets.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
